var map = {
	"./dropzone/index.js": 529,
	"./fields/index.js": 530,
	"./queue/index.js": 531,
	"./settings/index.js": 532
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2752;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/registration/product/batch \.\/[^\/]+\/index\.jsx?$
// module id = 2752
// module chunks = 0